var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "78cef3d1ef521e49d769bfd3e60ad3051cd2978c"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["gatsby@deltamath-2d0d222f8"] = {
  id: "78cef3d1ef521e49d769bfd3e60ad3051cd2978c"
};